import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';

import { GatewayHookSuccessResponse } from '../@types';
import { TokenexContextType, TokenexProvider } from '../contexts';
import { isStripe, isTokenex } from '../utils/typeGuards';

import { FailedToLoad } from './ui/FailedToLoad';

type ProviderProps = Omit<GatewayHookSuccessResponse, 'loaded'> & {
  children: React.ReactNode;
};

/**
 * @description Container component that provides the correct payment gateway context/provider
 * based on the detected provider type (Stripe, Tokenex, or fallback).
 *
 * @param {ProviderProps} props - Provider configuration and children.
 * @returns {JSX.Element} The context provider or error fallback.
 */
export const GatewayContainer: React.FC<ProviderProps> = ({
  provider,
  options,
  children,
}) => {
  if (isTokenex(provider)) {
    const config = {
      tokenexConfig: { ...options },
    } as TokenexContextType;
    return <TokenexProvider value={config}>{children}</TokenexProvider>;
  }
  if (isStripe(provider)) {
    return (
      <Elements options={options as StripeElementsOptions} stripe={provider}>
        {children}
      </Elements>
    );
  }
  return <FailedToLoad />;
};
